import { IPermissionModel } from './';

export const KAESSPermissions: IPermissionModel[] = [
	{
		name: 'Dashboard',
		route: '/',
		components: [
			'user-sufficiency-summary',
			'focus-products',
			'attendance-check',
			'total-out-off-view-site',
			'meeting-banner',
			'member-module',
			'power-BI',
		],
	},
	{ name: 'Scheme', route: '/scheme', components: [] },
	{ name: 'SiteSummary', route: '/site-summary', components: ['add-site-button', 'lost-leads'] },
	{ name: 'SiteSummary', route: '/site-summary/new-leads', components: ['add-site-button'] },
	{ name: 'Profile', route: '/profile', components: [] },
	{ name: 'ProductsRecommended', route: '/competition-conversion/products-recommended', components: [] },
	{ name: 'CompetitionConversion', route: '/competition-conversion', components: [] },
	{ name: 'CompetitionConversion', route: '/competition-conversion', components: [] },
	{ name: 'TypeOfContractor', route: '/competition-conversion/type-of-contractor', components: [] },
	{ name: 'GradeOfCompetition', route: '/competition-conversion/grade-of-competition', components: [] },
	{ name: 'PCMS', route: '/pcms', components: [] },
	{ name: 'HelpAndSupport', route: '/help-and-support', components: [] },
	{ name: 'SiteSummary', route: '/contractor/site-summary', components: [] },
	{ name: 'Calendar', route: '/calendar', components: [] },
	{
		name: 'KEASSAddNewSite',
		route: '/add-new-site-ss',
		components: ['kae-glue-fields', 'task-list-products', 'has-site-type-permission'],
	},
	{ name: 'ActivityModule', route: '/activity-module', components: [] },
	{ name: 'UserSufficiencySummary', route: '/user-sufficiency-summary', components: [] },
	{ name: 'SiteLeadOverview', route: '/site-lead-overview', components: [] },
	{ name: 'SiteDetails', route: '/site-lead-overview/site-details', components: [] },
	{ name: 'VisitDetails', route: '/site-lead-overview/visit-details', components: [] },
	{ name: 'StructureQuestionnaires', route: '/structured-questionnaires', components: [] },
	{ name: 'FieldMarketingContent', route: '/field-marketing-content', components: [] },
	{ name: 'Jharokha', route: '/jharokha', components: [] },
];
